export const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    team: 'Team',
    clients: 'Clients',
    packages: 'Packages',
    designRequests: 'Design Requests',
    mediaLibrary: 'Media Library',
    editor: 'Editor',
    posts: 'Posts',
    scheduledPosts: 'Scheduled Posts',
    settings: 'Settings',
    agencies: 'Agencies',
    plans: 'Plans',
    features: 'Features',
    reports: 'Reports',
    tickets: 'Tickets',
    contentAndPosts: 'Content & Posts',
    teamAndClients: 'Team & Clients',
    seoSection: 'SEO',
    seoPlans: 'SEO Plans',
    seoPlansTitle: 'SEO Plans',
    seoPlansSubtitle: 'Manage keywords and plans for each client',
    seoSelectClient: 'Select a client to start',
    seoNoPlans: 'No SEO plans for this client yet.',
    seoNoPlansCreate: 'No SEO plans for this client yet. Start by creating a new plan.',
    seoBackToPlans: 'Back to plans',
    seoKeywordsCount: 'keywords',
    seoGenerateLink: 'Generate approval link',
    seoCopyLink: 'Copy link',
    seoLinkCopied: 'Link copied!',
    seoClientReview: 'Client can approve keywords via this link',
    support: 'Support',
    management: 'Management',
    
    // Auth
    appName: 'sls',
    welcomeToApp: 'Welcome to sls',
    chooseOption: 'Choose an option to continue',
    createNewAgency: 'Create New Agency Account',
    signInExisting: 'Sign In to Existing Account',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign In',
    signInToAccount: 'Sign in to your account',
    contentApprovalSimple: 'Content approval made simple',
    emailAddress: 'Email address',
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: '••••••••',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    signingIn: 'Signing in...',
    dontHaveAccount: "Don't have an account?",
    createNewAccount: 'Create new account',
    or: 'or',
    
    // Dashboard
    welcome: 'Welcome back',
    reviewAndApprove: 'Review and approve your content',
    manageWorkflow: 'Manage your content approval workflow',
    totalClients: 'Total Clients',
    designers: 'Designers',
    writers: 'Writers',
    totalPosts: 'Total Posts',
    pendingApproval: 'Pending Approval',
    approved: 'Approved',
    needsChanges: 'Needs Changes',
    pendingPosts: 'Pending Posts',
    approvedPosts: 'Approved Posts',
    recentPosts: 'Recent Posts',
    recentClients: 'Recent Clients',
    viewAll: 'View all',
    quickActions: 'Quick Actions',
    addNewClient: 'Add New Client',
    createNewPost: 'Create New Post',
    viewAllPosts: 'View All Posts',
    viewAllClients: 'View All Clients',
    noPosts: 'No posts yet',
    noClients: 'No clients yet',
    needsAttention: 'Needs Attention',
    tryAgain: 'Try Again',
    clientsTitle: 'Clients',
    clientsSubtitle: 'Manage your client accounts',
    noClientsHeader: 'No Clients Yet',
    noClientsDescription: 'Start by adding your first client to begin managing content',
    addFirstClient: 'Add Your First Client',
    contactLabel: 'Contact:',
    emailLabel: 'Email:',
    createdLabel: 'Created:',
    socialMediaLabel: 'Social Media',
    yourClients: 'Your Clients',
    backToClients: '← Back to Clients',
    clientNotFound: 'Client not found',
    tryAgainClients: 'Try Again',
    allPostsFilter: 'All Posts',
    postsStatistics: 'Posts Statistics',
    companyInformation: 'Company Information',
    contactInformation: 'Contact Information',
    approvalRate: 'Approval Rate',
    pendingLabel: 'Pending',
    approvedLabel: 'Approved',
    needsChangesLabel: 'Needs Changes',
    noPostsFound: 'No posts found',
    createFirstPost: 'Create the first post →',
    postsTitle: 'Posts',
    postsSubtitleClient: 'Your content waiting for approval',
    postsSubtitleAdmin: 'Manage all content posts',
    moreFilters: 'More Filters',
    filterPlatformLabel: 'Platform',
    filterContentTypeLabel: 'Content Type',
    filterClear: 'Clear Filters',
    filterAllClients: 'All Clients',
    filterAllPlatforms: 'All Platforms',
    filterAllTypes: 'All Types',
    gridView: 'Grid View',
    listView: 'List View',
    deleteSelected: 'Delete Selected',
    clearSelection: 'Clear Selection',
    selectAll: 'Select All',
    noImage: 'No image',
    noVideo: 'No video',
    postPreview: 'Post Preview',
    postInfo: 'Post Information',
    clientLabel: 'Client:',
    platformLabel: 'Platform:',
    contentTypeLabel: 'Content Type:',
    dateLabel: 'Date:',
    viewDetails: 'View Details',
    preview: 'Preview',
    approvePost: 'Approve Post',
    deletePost: 'Delete Post',
    noPostsFoundForFilters: 'No posts found',
    viewAllPosts: 'View All Posts',
    createYourFirstPost: 'Create Your First Post',
    postsSelected: 'post selected',
    postsSelectedPlural: 'posts selected',
    confirmApprovePost: 'Are you sure you want to approve this post?',
    confirmDeletePost: 'Are you sure you want to delete this post? It will be moved to trash.',
    confirmBulkDeletePosts: 'Are you sure you want to delete {count} post(s)? They will be moved to trash.',
    postApprovedSuccess: 'Post approved successfully!',
    postDeletedSuccess: 'Post deleted successfully!',
    postsDeletedSuccess: '{count} post(s) deleted successfully!',
    viewFullDetails: 'View Full Details',
    approve: 'Approve',
    
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    update: 'Update',
    create: 'Create',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    remove: 'Remove',
    select: 'Select',
    choose: 'Choose',
    upload: 'Upload',
    download: 'Download',
    view: 'View',
    show: 'Show',
    hide: 'Hide',
    home: 'Home',
    active: 'Active',
    inactive: 'Inactive',
    status: 'Status',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    description: 'Description',
    date: 'Date',
    time: 'Time',
    actions: 'Actions',
    
    // Settings
    profile: 'Your Profile',
    logout: 'Logout',
    agencyInformation: 'Agency Information',
    agencyName: 'Agency Name',
    agencyLogo: 'Agency Logo',
    subscriptionInformation: 'Subscription Information',
    plan: 'Plan',
    subscriptionStatus: 'Subscription Status',
    saveSettings: 'Save Settings',
    settingsUpdated: 'Settings updated successfully',
    changeLogo: 'Change Logo',
    chooseLogo: 'Choose Logo',
    removeLogo: 'Remove',
    
    // Notifications
    notifications: 'Notifications',
    noNotifications: 'No notifications',
    markAsRead: 'Mark as read',
    markAllAsRead: 'Mark all as read',
    deleteNotification: 'Delete',
    clearRead: 'Clear read',
    
    // Status
    pending: 'Pending',
    needs_changes: 'Needs Changes',
    approved_status: 'Approved',
    
    // Roles
    admin: 'Admin',
    designer: 'Designer',
    writer: 'Writer',
    client: 'Client',
    superAdmin: 'Super Admin',
    seoSpecialist: 'SEO Specialist',
    teamManager: 'Team Manager',
    
    // Team Members
    teamMembersTitle: 'Team Members',
    teamMembersSubtitle: 'Manage designers and writers in your agency',
    manageTeam: 'Manage designers and writers in your agency',
    addTeamMember: 'Add Team Member',
    all: 'All',
    allUsersFilter: 'All',
    designersFilter: 'Designers',
    writersFilter: 'Writers',
    seoSpecialistsFilter: 'SEO Specialists',
    noTeamMembersYet: 'No team members yet',
    noRoleYet: 'No {role}s yet',
    addYourFirstTeamMember: 'Add Your First Team Member',
    nameColumn: 'Name',
    emailColumn: 'Email',
    roleColumn: 'Role',
    statusColumn: 'Status',
    joinedColumn: 'Joined',
    actionsColumn: 'Actions',
    editButton: 'Edit',
    deleteButton: 'Delete',
    confirmDeleteUser: 'Are you sure you want to delete this user? This action cannot be undone.',
    userDeletedSuccess: 'User deleted successfully!',
    deleting: 'Deleting...',
    editTeamMember: 'Edit Team Member',
    passwordLoginTip: 'The user will use this email and password to login',
    updateUser: 'Update User',
    createUser: 'Create User',
    saving: 'Saving...',
    notSet: 'Not set',
    phoneNumber: 'Phone Number',
    whatsappNumber: 'WhatsApp Number',
    website: 'Website',
    archive: 'Archive',
    companyName: 'Company Name',
    
    // Design Requests
    designRequestsTitle: 'Design Requests',
    designRequestsSubtitleClient: 'Request new designs for your content',
    designRequestsSubtitleAdmin: 'Manage design requests from clients',
    newDesignRequest: '+ New Design Request',
    allRequestsFilter: 'All',
    pendingRequestsFilter: 'Pending',
    inProgressRequestsFilter: 'In Progress',
    completedRequestsFilter: 'Completed',
    noDesignRequests: 'No design requests found',
    createYourFirstDesignRequest: 'Create Your First Design Request',
    
    // Media Library
    mediaLibraryTitle: 'Media Library',
    mediaLibrarySubtitle: 'Manage and organize your image and video files',
    uploadMedia: 'Upload Files',
    createFolder: 'New Folder',
    uploadFolder: 'Upload Folder',
    bulkCreatePosts: 'Create {count} Post(s)',
    allMediaFilter: 'All',
    imagesFilter: 'Images',
    videosFilter: 'Videos',
    foldersFilter: 'Folders',
    searchMedia: 'Search...',
    noMediaFound: 'No media files uploaded yet',
    noMediaFoundForFilters: 'No media found for the selected filters',
    uploadYourFirstMedia: 'Upload Your First File',
    noFolders: 'No folders',
    files: 'files',
    folders: 'folders',
    dragFilesToUpload: 'Drag files here or click to upload',
    uploadMediaDescription: 'Supports images and videos (max 50 files) - You can upload entire folders',
    chooseFolder: 'Choose Folder',
    chooseFiles: 'Choose Files',
    invalidMediaFiles: 'Please select valid image or video files',
    maxFilesLimit: 'Maximum 50 files at once',
    confirmDeleteMedia: 'Are you sure you want to delete this file?',
    mediaDeletedSuccess: 'File deleted successfully!',
    confirmDeleteFolder: 'Are you sure you want to delete this folder?',
    folderDeletedSuccess: 'Folder deleted successfully!',
    showingMedia: 'Showing {start}-{end} of {total} files',
    
    // Tickets
    ticketsTitle: 'Tickets',
    ticketsSubtitle: 'Manage support tickets and feature requests',
    manageTicketsTitle: 'Manage Tickets',
    manageTicketsSubtitle: 'View and manage all support tickets from agencies',
    newTicket: 'New Ticket',
    createNewTicket: 'Create New Ticket',
    editTicket: 'Edit Ticket',
    ticketSubject: 'Subject',
    ticketDescription: 'Description',
    ticketCategory: 'Category',
    ticketPriority: 'Priority',
    ticketStatus: 'Status',
    ticketNumber: 'Ticket Number',
    ticketCreatedBy: 'Created By',
    ticketAssignedTo: 'Assigned To',
    ticketResolvedAt: 'Resolved At',
    ticketResolution: 'Resolution',
    noTickets: 'No tickets found',
    onlyOpenTicketsEditable: 'Only open tickets can be edited',
    ticketCreatedSuccess: 'Ticket created successfully',
    ticketUpdatedSuccess: 'Ticket updated successfully',
    ticketDeletedSuccess: 'Ticket deleted',
    confirmDeleteTicket: 'Are you sure you want to delete this ticket?',
    allCategories: 'All Categories',
    allAgencies: 'All Agencies',
    unassigned: 'Unassigned',
    assignTo: 'Assign to:',
    changeStatus: 'Change Status:',
    addResolution: 'Add Resolution:',
    saveResolution: 'Save Resolution',
    resolutionPlaceholder: 'Write resolution or response here...',
    categoryTechnical: 'Technical',
    categoryBilling: 'Billing',
    categoryFeatureRequest: 'Feature Request',
    categoryBug: 'Bug',
    categoryOther: 'Other',
    priorityLow: 'Low',
    priorityMedium: 'Medium',
    priorityHigh: 'High',
    priorityUrgent: 'Urgent',
    statusOpen: 'Open',
    statusInProgress: 'In Progress',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    ticketSubjectPlaceholder: 'Ticket subject',
    ticketDescriptionPlaceholder: 'Detailed description of the issue or request',
    requiredFields: 'Please fill in all required fields',
    by: 'By:',
    accessDenied: 'You do not have access to this page',
    manageButton: 'Manage',
    cancelButton: 'Cancel',
    deleteButton: 'Delete',
    saveChanges: 'Save Changes',
    createTicket: 'Create Ticket',
    
    // Import/Export
    import: 'Import',
    importPosts: 'Import Posts',
    importPostsFromCSV: 'Import Posts from CSV',
    selectCSVFile: 'Select CSV File',
    chooseFile: 'Choose File',
    downloadSample: 'Download Sample',
    selectedFile: 'Selected file:',
    dataPreview: 'Data Preview',
    showingFirstRowsOnly: 'Showing first 10 rows only for preview',
    importPostsButton: 'Import Posts',
    importantNotes: 'Important Notes:',
    requiredFieldsNote: 'Required fields: Title, Platform, Content Type',
    platformMustBe: 'Platform must be: instagram, facebook, twitter, tiktok, snapchat, linkedin, youtube, website',
    contentTypeMustBe: 'Content Type must be: image, video, carousel, story, reel, product, blog, banner',
    serialNumberNote: 'If Serial Number is provided and already exists, row will be skipped',
    clientNameMustMatch: 'Client Name must match an existing client name',
    importResults: 'Import Results',
    succeeded: 'Succeeded',
    failed: 'Failed',
    skipped: 'Skipped',
    failedRows: 'Failed Rows:',
    skippedRows: 'Skipped Rows:',
    pleaseSelectCSVFileOnly: 'Please select a CSV file only',
    fileIsEmptyOrInvalid: 'File is empty or invalid',
    failedToReadFile: 'Failed to read file',
  },
  ar: {
    // Navigation
    dashboard: 'لوحة التحكم',
    team: 'الفريق',
    clients: 'العملاء',
    packages: 'الباقات',
    designRequests: 'طلبات التصميم',
    mediaLibrary: 'مكتبة الوسائط',
    editor: 'قسم التحرير',
    posts: 'البوستات',
    scheduledPosts: 'المنشورات المجدولة',
    settings: 'الإعدادات',
    agencies: 'الوكالات',
    plans: 'الباقات',
    features: 'الميزات',
    reports: 'التقارير',
    tickets: 'التذاكر',
    contentAndPosts: 'المحتوى والمنشورات',
    teamAndClients: 'الفريق والعملاء',
    seoSection: 'SEO',
    seoPlans: 'خطط SEO',
    seoPlansTitle: 'خطط SEO',
    seoPlansSubtitle: 'إدارة الكلمات المفتاحية والخطط لكل عميل',
    seoSelectClient: 'اختر عميلاً للبدء',
    seoNoPlans: 'لا توجد خطط SEO لهذا العميل.',
    seoNoPlansCreate: 'لا توجد خطط SEO لهذا العميل بعد. ابدأ بإنشاء خطة جديدة.',
    seoBackToPlans: 'العودة للخطط',
    seoKeywordsCount: 'كلمة',
    seoGenerateLink: 'إنشاء رابط تعميد',
    seoCopyLink: 'نسخ الرابط',
    seoLinkCopied: 'تم نسخ الرابط!',
    seoClientReview: 'العميل يمكنه تعميد الكلمات عبر هذا الرابط',
    support: 'الدعم',
    management: 'الإدارة',
    
    // Auth
    appName: 'سَلِس',
    welcomeToApp: 'مرحباً بك في سَلِس',
    chooseOption: 'اختر خياراً للمتابعة',
    createNewAgency: 'إنشاء حساب وكالة جديد',
    signInExisting: 'تسجيل الدخول إلى حساب موجود',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    signIn: 'تسجيل الدخول',
    signInToAccount: 'تسجيل الدخول إلى حسابك',
    contentApprovalSimple: 'الموافقة على المحتوى بشكل بسيط',
    emailAddress: 'البريد الإلكتروني',
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: '••••••••',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    signingIn: 'جاري تسجيل الدخول...',
    dontHaveAccount: 'ليس لديك حساب؟',
    createNewAccount: 'إنشاء حساب جديد',
    or: 'أو',
    
    // Dashboard
    welcome: 'مرحباً بعودتك',
    reviewAndApprove: 'راجع وأقر محتواك',
    manageWorkflow: 'إدارة سير عمل الموافقة على المحتوى',
    totalClients: 'إجمالي العملاء',
    designers: 'المصممين',
    writers: 'الكتّاب',
    totalPosts: 'إجمالي البوستات',
    pendingApproval: 'في انتظار الموافقة',
    approved: 'معتمد',
    needsChanges: 'يحتاج تعديل',
    pendingPosts: 'البوستات المعلقة',
    approvedPosts: 'البوستات المعتمدة',
    recentPosts: 'البوستات الأخيرة',
    recentClients: 'العملاء الأخيرين',
    viewAll: 'عرض الكل',
    quickActions: 'إجراءات سريعة',
    addNewClient: 'إضافة عميل جديد',
    createNewPost: 'إنشاء بوست جديد',
    viewAllPosts: 'عرض جميع البوستات',
    viewAllClients: 'عرض جميع العملاء',
    noPosts: 'لا توجد بوستات بعد',
    noClients: 'لا يوجد عملاء بعد',
    needsAttention: 'يحتاج انتباه',
    tryAgain: 'حاول مرة أخرى',
    clientsTitle: 'العملاء',
    clientsSubtitle: 'إدارة حسابات العملاء',
    noClientsHeader: 'لا يوجد عملاء',
    noClientsDescription: 'ابدأ بإضافة عميلك الأول للبدء في إدارة المحتوى',
    addFirstClient: 'إضافة أول عميل',
    contactLabel: 'جهة الاتصال:',
    emailLabel: 'البريد:',
    createdLabel: 'تاريخ الإنشاء:',
    socialMediaLabel: 'وسائل التواصل الاجتماعي',
    yourClients: 'عملاؤك',
    backToClients: '← العودة للعملاء',
    clientNotFound: 'العميل غير موجود',
    tryAgainClients: 'حاول مرة أخرى',
    allPostsFilter: 'كل البوستات',
    postsStatistics: 'إحصائيات البوستات',
    companyInformation: 'معلومات الشركة',
    contactInformation: 'معلومات التواصل',
    approvalRate: 'معدل التعميد',
    pendingLabel: 'قيد المراجعة',
    approvedLabel: 'معتمد',
    needsChangesLabel: 'يحتاج تعديلات',
    noPostsFound: 'لا توجد بوستات',
    createFirstPost: 'إنشاء أول بوست →',
    postsTitle: 'البوستات',
    postsSubtitleClient: 'محتواك بانتظار الاعتماد',
    postsSubtitleAdmin: 'إدارة جميع البوستات',
    moreFilters: 'فلتر إضافي',
    filterPlatformLabel: 'المنصة',
    filterContentTypeLabel: 'نوع المحتوى',
    filterClear: 'إزالة الفلاتر',
    filterAllClients: 'جميع العملاء',
    filterAllPlatforms: 'جميع المنصات',
    filterAllTypes: 'جميع الأنواع',
    gridView: 'عرض شبكي',
    listView: 'عرض قائمة',
    deleteSelected: 'حذف المحدد',
    clearSelection: 'إلغاء التحديد',
    selectAll: 'تحديد الكل',
    noImage: 'لا توجد صورة',
    noVideo: 'لا يوجد فيديو',
    postPreview: 'معاينة البوست',
    postInfo: 'معلومات البوست',
    clientLabel: 'العميل:',
    platformLabel: 'المنصة:',
    contentTypeLabel: 'نوع المحتوى:',
    dateLabel: 'التاريخ:',
    viewDetails: 'عرض التفاصيل',
    preview: 'معاينة',
    approvePost: 'تعميد البوست',
    deletePost: 'حذف البوست',
    noPostsFoundForFilters: 'لا توجد بوستات',
    viewAllPosts: 'عرض جميع البوستات',
    createYourFirstPost: 'أنشئ أول بوست لك',
    postsSelected: 'بوست محدد',
    postsSelectedPlural: 'بوست محدد',
    confirmApprovePost: 'هل أنت متأكد من تعميد هذا البوست؟',
    confirmDeletePost: 'هل أنت متأكد من حذف هذا البوست؟ سيتم نقله إلى سلة المحذوفات.',
    confirmBulkDeletePosts: 'هل أنت متأكد من حذف {count} بوست؟ سيتم نقلهم إلى سلة المحذوفات.',
    postApprovedSuccess: 'تم تعميد البوست بنجاح!',
    postDeletedSuccess: 'تم حذف البوست بنجاح!',
    postsDeletedSuccess: 'تم حذف {count} بوست بنجاح!',
    viewFullDetails: 'عرض التفاصيل الكاملة',
    approve: 'تعميد',
    
    // Common
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    update: 'تحديث',
    create: 'إنشاء',
    search: 'بحث',
    filter: 'تصفية',
    clear: 'مسح',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    confirm: 'تأكيد',
    yes: 'نعم',
    no: 'لا',
    ok: 'موافق',
    remove: 'إزالة',
    select: 'اختر',
    choose: 'اختر',
    upload: 'رفع',
    download: 'تحميل',
    view: 'عرض',
    show: 'إظهار',
    hide: 'إخفاء',
    home: 'الرئيسية',
    active: 'نشط',
    inactive: 'غير نشط',
    status: 'الحالة',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    description: 'الوصف',
    date: 'التاريخ',
    time: 'الوقت',
    actions: 'الإجراءات',
    
    // Settings
    profile: 'ملفك الشخصي',
    logout: 'تسجيل الخروج',
    agencyInformation: 'معلومات الوكالة',
    agencyName: 'اسم الوكالة',
    agencyLogo: 'شعار الوكالة',
    subscriptionInformation: 'معلومات الاشتراك',
    plan: 'الباقة',
    subscriptionStatus: 'حالة الاشتراك',
    saveSettings: 'حفظ الإعدادات',
    settingsUpdated: 'تم تحديث الإعدادات بنجاح',
    changeLogo: 'تغيير الشعار',
    chooseLogo: 'اختر الشعار',
    removeLogo: 'إزالة',
    
    // Notifications
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    markAsRead: 'تعليم كمقروء',
    markAllAsRead: 'تعليم الكل كمقروء',
    deleteNotification: 'حذف',
    clearRead: 'مسح المقروء',
    
    // Status
    pending: 'معلق',
    needs_changes: 'يحتاج تعديل',
    approved_status: 'معتمد',
    
    // Roles
    admin: 'مدير',
    designer: 'مصمم',
    writer: 'كاتب',
    client: 'عميل',
    superAdmin: 'مدير عام',
    seoSpecialist: 'أخصائي SEO',
    teamManager: 'مدير الفريق',
    
    // Team Members
    teamMembersTitle: 'أعضاء الفريق',
    teamMembersSubtitle: 'إدارة المصممين والكتّاب في وكالتك',
    manageTeam: 'إدارة المصممين والكتّاب في وكالتك',
    addTeamMember: 'إضافة عضو فريق',
    all: 'الكل',
    allUsersFilter: 'الكل',
    designersFilter: 'المصممين',
    writersFilter: 'الكتّاب',
    seoSpecialistsFilter: 'أخصائيي SEO',
    noTeamMembersYet: 'لا يوجد أعضاء فريق بعد',
    noRoleYet: 'لا يوجد {role} بعد',
    addYourFirstTeamMember: 'أضف أول عضو فريق',
    nameColumn: 'الاسم',
    emailColumn: 'البريد الإلكتروني',
    roleColumn: 'الدور',
    statusColumn: 'الحالة',
    joinedColumn: 'تاريخ الانضمام',
    actionsColumn: 'الإجراءات',
    editButton: 'تعديل',
    deleteButton: 'حذف',
    confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟ لا يمكن التراجع عن هذا الإجراء.',
    userDeletedSuccess: 'تم حذف المستخدم بنجاح!',
    deleting: 'جاري الحذف...',
    editTeamMember: 'تعديل عضو الفريق',
    passwordLoginTip: 'سيستخدم المستخدم هذا البريد الإلكتروني وكلمة المرور لتسجيل الدخول',
    updateUser: 'تحديث المستخدم',
    createUser: 'إنشاء مستخدم',
    saving: 'جاري الحفظ...',
    notSet: 'غير محدد',
    phoneNumber: 'رقم الجوال',
    whatsappNumber: 'رقم واتساب',
    website: 'الموقع الإلكتروني',
    archive: 'أرشفة',
    companyName: 'اسم الشركة',
    
    // Design Requests
    designRequestsTitle: 'طلبات التصاميم',
    designRequestsSubtitleClient: 'اطلب تصاميم جديدة لمحتواك',
    designRequestsSubtitleAdmin: 'إدارة طلبات التصاميم من العملاء',
    newDesignRequest: '+ طلب تصميم جديد',
    allRequestsFilter: 'الكل',
    pendingRequestsFilter: 'قيد الانتظار',
    inProgressRequestsFilter: 'قيد التنفيذ',
    completedRequestsFilter: 'مكتمل',
    noDesignRequests: 'لا توجد طلبات تصميم',
    createYourFirstDesignRequest: 'إنشاء طلب تصميم جديد',
    
    // Media Library
    mediaLibraryTitle: 'مكتبة الوسائط',
    mediaLibrarySubtitle: 'إدارة وتنظيم ملفات الصور والفيديوهات',
    uploadMedia: 'رفع ملفات',
    createFolder: 'مجلد جديد',
    uploadFolder: 'رفع مجلد',
    bulkCreatePosts: 'إنشاء {count} بوست',
    allMediaFilter: 'الكل',
    imagesFilter: 'صور',
    videosFilter: 'فيديوهات',
    foldersFilter: 'مجلدات',
    searchMedia: 'بحث...',
    noMediaFound: 'لا توجد ملفات مرفوعة بعد',
    noMediaFoundForFilters: 'لا توجد ملفات للفلاتر المحددة',
    uploadYourFirstMedia: 'رفع أول ملف',
    noFolders: 'لا توجد مجلدات',
    files: 'ملف',
    folders: 'مجلد',
    dragFilesToUpload: 'اسحب الملفات هنا أو اضغط للرفع',
    uploadMediaDescription: 'يدعم الصور والفيديوهات (حد أقصى 50 ملف) - يمكنك رفع مجلد كامل',
    chooseFolder: 'اختر مجلد',
    chooseFiles: 'اختر الملفات',
    invalidMediaFiles: 'يرجى اختيار ملفات صور أو فيديوهات صحيحة',
    maxFilesLimit: 'الحد الأقصى 50 ملف في المرة الواحدة',
    confirmDeleteMedia: 'هل أنت متأكد من حذف هذا الملف؟',
    mediaDeletedSuccess: 'تم حذف الملف بنجاح!',
    confirmDeleteFolder: 'هل أنت متأكد من حذف هذا المجلد؟',
    folderDeletedSuccess: 'تم حذف المجلد بنجاح!',
    showingMedia: 'عرض {start}-{end} من {total} ملف',
    
    // Tickets
    ticketsTitle: 'التذاكر',
    ticketsSubtitle: 'إدارة تذاكر الدعم الفني وطلبات الميزات',
    manageTicketsTitle: 'إدارة التذاكر',
    manageTicketsSubtitle: 'عرض وإدارة جميع تذاكر الدعم الفني من الوكالات',
    newTicket: 'تذكرة جديدة',
    createNewTicket: 'إنشاء تذكرة جديدة',
    editTicket: 'تعديل التذكرة',
    ticketSubject: 'الموضوع',
    ticketDescription: 'الوصف',
    ticketCategory: 'الفئة',
    ticketPriority: 'الأولوية',
    ticketStatus: 'الحالة',
    ticketNumber: 'رقم التذكرة',
    ticketCreatedBy: 'تم الإنشاء بواسطة',
    ticketAssignedTo: 'معين إلى',
    ticketResolvedAt: 'تم الحل في',
    ticketResolution: 'الحل',
    noTickets: 'لا توجد تذاكر',
    onlyOpenTicketsEditable: 'يمكن تعديل التذاكر المفتوحة فقط',
    ticketCreatedSuccess: 'تم إنشاء التذكرة بنجاح',
    ticketUpdatedSuccess: 'تم تحديث التذكرة بنجاح',
    ticketDeletedSuccess: 'تم حذف التذكرة',
    confirmDeleteTicket: 'هل أنت متأكد من حذف هذه التذكرة؟',
    allCategories: 'كل الفئات',
    allAgencies: 'كل الوكالات',
    unassigned: 'غير معين',
    assignTo: 'تعيين إلى:',
    changeStatus: 'تغيير الحالة:',
    addResolution: 'إضافة حل:',
    saveResolution: 'حفظ الحل',
    resolutionPlaceholder: 'اكتب الحل أو الرد هنا...',
    categoryTechnical: 'فني',
    categoryBilling: 'الفوترة',
    categoryFeatureRequest: 'طلب ميزة',
    categoryBug: 'خطأ',
    categoryOther: 'أخرى',
    priorityLow: 'منخفضة',
    priorityMedium: 'متوسطة',
    priorityHigh: 'عالية',
    priorityUrgent: 'عاجلة',
    statusOpen: 'مفتوحة',
    statusInProgress: 'قيد المعالجة',
    statusResolved: 'تم الحل',
    statusClosed: 'مغلقة',
    ticketSubjectPlaceholder: 'موضوع التذكرة',
    ticketDescriptionPlaceholder: 'وصف تفصيلي للمشكلة أو الطلب',
    requiredFields: 'يرجى ملء جميع الحقول المطلوبة',
    by: 'بواسطة:',
    accessDenied: 'غير مصرح لك بالوصول إلى هذه الصفحة',
    manageButton: 'إدارة',
    cancelButton: 'إلغاء',
    deleteButton: 'حذف',
    saveChanges: 'حفظ التغييرات',
    createTicket: 'إنشاء التذكرة',
    
    // Import/Export
    import: 'استيراد',
    importPosts: 'استيراد البوستات',
    importPostsFromCSV: 'استيراد البوستات من CSV',
    selectCSVFile: 'اختر ملف CSV',
    chooseFile: 'اختر ملف',
    downloadSample: 'تحميل نموذج',
    selectedFile: 'الملف المحدد:',
    dataPreview: 'معاينة البيانات',
    showingFirstRowsOnly: 'يتم عرض أول 10 صفوف فقط للمعاينة',
    importPostsButton: 'استيراد البوستات',
    importantNotes: 'ملاحظات مهمة:',
    requiredFieldsNote: 'الحقول المطلوبة: Title, Platform, Content Type',
    platformMustBe: 'Platform يجب أن يكون: instagram, facebook, twitter, tiktok, snapchat, linkedin, youtube, website',
    contentTypeMustBe: 'Content Type يجب أن يكون: image, video, carousel, story, reel, product, blog, banner',
    serialNumberNote: 'إذا تم توفير Serial Number وكان موجوداً بالفعل، سيتم تخطي الصف',
    clientNameMustMatch: 'Client Name يجب أن يطابق اسم عميل موجود',
    importResults: 'نتائج الاستيراد',
    succeeded: 'نجح',
    failed: 'فشل',
    skipped: 'تم التخطي',
    failedRows: 'الصفوف الفاشلة:',
    skippedRows: 'الصفوف المتخطاة:',
    pleaseSelectCSVFileOnly: 'يرجى اختيار ملف CSV فقط',
    fileIsEmptyOrInvalid: 'الملف فارغ أو غير صالح',
    failedToReadFile: 'فشل قراءة الملف',
  },
};

export const t = (key, language = 'en') => {
  return translations[language]?.[key] || key;
};

